var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7749 16.5034C20.4158 17.6342 19.6113 19.0476 18.3313 19.0476H1.66855C0.386017 19.0476 -0.414747 17.632 0.224906 16.5034L8.55636 1.80008C9.19758 0.668806 10.8036 0.670856 11.4437 1.80008L19.7749 16.5034ZM10 13.4636C9.11789 13.4636 8.40279 14.1914 8.40279 15.0893C8.40279 15.9872 9.11789 16.715 10 16.715C10.8821 16.715 11.5972 15.9872 11.5972 15.0893C11.5972 14.1914 10.8821 13.4636 10 13.4636ZM8.48358 7.61985L8.74115 12.4264C8.7532 12.6513 8.93591 12.8274 9.15719 12.8274H10.8428C11.0641 12.8274 11.2468 12.6513 11.2589 12.4264L11.5164 7.61985C11.5295 7.37691 11.3394 7.17263 11.1004 7.17263H8.89959C8.66056 7.17263 8.47056 7.37691 8.48358 7.61985Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1fe9efed.svg";
export { ForwardRef as ReactComponent };